<template>
  <div>


      <el-container class="SelectBlock">

        <el-col class="FirstBlock" :sapn="3" >
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              选择查询的需要<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">根据菜单名称查询</el-dropdown-item>
              <el-dropdown-item command="b">根据菜单按钮查询</el-dropdown-item>
              <el-dropdown-item command="c">根据操作账户查询</el-dropdown-item>
              <el-dropdown-item command="d">根据操作内容查询</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>




            <el-input v-if="selectCheck == 'a'" v-model="SForm.menuName" placeholder="根据菜单名称查询"></el-input>
             <el-input v-if="selectCheck == 'b'" v-model="SForm.menuBtn" placeholder="根据菜单按钮查询"></el-input>
             <el-input v-if="selectCheck == 'c'" v-model="SForm.opAccount" placeholder="根据操作账户查询"></el-input>
             <el-input v-if="selectCheck == 'd'" v-model="SForm.opContent" placeholder="根据操作内容查询"></el-input>




          <el-button type="primary" @click="select(1)">查询</el-button>
          <el-button type="primary" @click="resetForm('SForm')">重置</el-button>
        </el-col>

      </el-container>



    <div>
      <el-table
          :data="tableData"
          style="width: 100%"
          >
          <el-table-column
            fixed
            prop="menuName"
            label="菜单名"
            width="150">
          </el-table-column>
          <el-table-column
            prop="menuBtn"
            label="按钮名"
            width="120">
          </el-table-column>
          <el-table-column
            prop="url"
            label="请求路径"
            width="120">
          </el-table-column>
          <el-table-column
            prop="className"
            label="类路径"
            width="120">
          </el-table-column>




          <el-table-column
            prop="methodName"
            label="方法名"
            width="120">
          </el-table-column>

          <el-table-column
            prop="reqType"
            label="请求方式"
            width="120">
          </el-table-column>
          <el-table-column
            prop="params"
            label="请求参数"

            width="120">
          </el-table-column>
          <el-table-column
            prop="success"
            label="是否成功"
            width="120">
          </el-table-column>

          <el-table-column
            label="操作时间"
            width="250">
            <template slot-scope="scope">
             {{formattedTime(scope.row.opTime)}}</template>

          </el-table-column>


          <el-table-column
            prop="opAccount"
            label="操作人"
            width="120">
          </el-table-column>
          <el-table-column
            prop="opContent"
            label="操作内容"
            width="120">
          </el-table-column>
          <el-table-column
            prop="opIp"
            label="IP"
            width="120">
          </el-table-column>

        </el-table>
        <div class="block">
            <el-pagination
                 @size-change="handleSizeChange"
                 @current-change="select"
                 :current-page="currentPage"
                 :page-sizes="[10, 20, 50, 100]"
                 :page-size="pageSize"
                 layout="total, sizes, prev, pager, next, jumper"
                 :total="total">
               </el-pagination>
          </div>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  export default {
     name: 'Log',
     data () {
       return {
         drawer: false,
		 currentPage:1,
		 pageSize:20,
		 total:0,
         selectCheck:'',
         direction: 'rtl',
         SForm:{
           menuName:'',
           menuBtn:'',
           opAccount:'',
           opContent:'',
         },
           tableData: [{
                   id:'',
                   menuName:'',
                   menuBtn:'',
                   url:'',
                   className:'',
                   methodName:'',
                   reqType:'',
                   params:'',
                   success:'',
                   result:'',
                   opTime:'',
                   opAccount:'',
                   opContent:'',
                   opIp:'',
                  }]
        };
     },
     created:function() {
       this.showData();
     },
     methods: {
      formattedTime(val) {
              const date = new Date(val);
              const year = date.getFullYear();
              const month = ("0" + (date.getMonth() + 1)).slice(-2);
              const day = ("0" + date.getDate()).slice(-2);
              return `${year}-${month}-${day} `;
            },

       handleCommand(command) {
              this.selectCheck = command
             },


           resetForm(formName) {
             Object.assign(this.$data.SForm, this.$options.data().SForm)
             this.select()
               },
		handleSizeChange(val){
				 this.pageSize = val
				 this.select()
		},
       select(val){
          var authorization = Cookies.get("Authorization");
          var paramsData = {
            currentPage: val || 1 || undefined,
            pageSize: this.pageSize,
            menuName:this.SForm.menuName || undefined,
            menuBtn:this.SForm.menuBtn || undefined,
            opAccount:this.SForm.opAccount || undefined,
            opContent:this.SForm.opContent || undefined,
          }

           this.axios({
               method: 'GET',
               url: '/log/showLog',
               params:paramsData,
               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{
                this.tableData=resp.data.data;
                this.total = resp.data.count;
             })
       },
      showData(){
       var authorization = Cookies.get("Authorization");
       var params = {
         currentPage: 1,
         pageSize: 10,
       }
        this.axios({
            method: 'GET',
            url: '/log/showLog',
            params:params,
            header:{
              'Authorization':authorization,
            	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            	}
          }).then((resp)=>{
           this.tableData=resp.data.data;
           this.total = resp.data.count;
          })
      },
     }
   }
</script>

<style>
  .SelectBlock .el-input{
    width: 400px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Munber/Log.vue